//印尼语
export default {
    borrow: {
        Bo1: 'Mata uang peminjaman',
        Bo2: 'Membantu Anda menjelajahi lebih banyak peluang trading dan produk keuangan',
        Bo3: 'aturan pinjaman uang',
        Bo4: 'Jika',
        Bo5: 'Kembali dalam beberapa hari: kadar bunga tetap untuk siklus adalah',
        Bo6: "Pembayaran yang terlambat sehari-hari akan dibayar untuk pembayaran yang terlambat",
        Bo7: 'Hukuman bunga. Saya sarankan Anda mempertimbangkan dengan hati-hati kemampuan Anda untuk membayar koin sebelum meminjamnya untuk menghindari biaya tambahan yang tidak perlu',
        Bo8: 'Batal',
        Bo9: 'Konfirmasi',
        Bo10: 'Kembalikan koin',
        Bo11: 'Perhatian: Ada perbedaan antara alamat isi ulang dan alamat pembayaran. Untuk menghindari kesalahan operasional, pastikan koin dikembalikan ke alamat pembayaran yang benar.',
        Bo12: 'Alamat dompet:',
        Bo13: 'Ditolak - Ditolak sambil menunggu perbaikan',
        Bo14: 'Alasan penolakan:',
        Bo15: 'lanjutkan penyuntingan',
        Bo16: 'Sedang ditinjau - berhasil dikirim, Personel terkait akan meninjau aplikasi pinjaman Anda dalam waktu 24 jam. Silakan periksa kotak masuk Anda',
        Bo17: 'Disetujui - Batas kredit yang dikeluarkan',
        Bo18: 'Anda dapat memasukkan akun koin Anda untuk melihat',
        Bo19: 'Hari yang dipinjam',
        Bo20: 'Pembayaran jatuh tempo',
        Bo21: 'Termasuk bunga',
        Bo22: 'Satu klik pembayaran',
        Bo23: 'Informasi peminjaman mata uang',
        Bo24: 'Nama bank',
        Bo25: 'Nomor Kartu Bank',
        Bo26: 'Batas pinjaman yang dimaksudkan (USDT)',
        Bo27: 'Bukti Dokumen identifikasi pribadi',
        Bo28: 'Bagian depan dan belakang kartu identitas',
        Bo29: 'Klik untuk mengunggah',
        Bo30: 'Nama lengkap',
        Bo31: 'Nomor telepon yang sering digunakan',
        Bo32: 'Nomor identitas',
        Bo33: 'Alamat tempat tinggal terdaftar',
        Bo34: 'Alamat tempat tinggal saat ini',
        Bo35: 'Bukti Dokumen Informasi Penjamin',
        Bo36: 'Nama penjamin',
        Bo37: 'Nomor kontak',
        Bo38: 'Hubungan dengan pelanggan',
        Bo39: 'Alamat tempat tinggal',
        Bo40: 'Bukti Penghasilan (Tips: Anda dapat mengunggah laporan gaji, bukti pekerjaan, dll.)',
        Bo41: 'Bukti Penghasilan',
        Bo42: 'Bukti aset (catatan: Anda dapat mengunggah bukti properti, bukti kendaraan, dan bukti setoran)',
        Bo43: 'Bukti Asset',
        Bo44: 'Informasi lainnya',
        Bo45: 'Pengiriman materi peminjaman',
        Bo46: 'Tolong naik kartu ID depan dan belakang Anda',
        Bo47: "Kumohon naik bukti pendapatan",
        Bo48: "Kumohon mengunggah bukti aset",
        Bo49: 'Pengguna meminjam koin',
        Bo50: 'Daftar Kembali',
        Bo51: 'Meminjam mata uang memiliki risiko, dan hasil akhir tergantung pada tinjauan aktual.',
        Bo52: 'Mengapa memilih untuk meminjam mata uang?',
        Bo53: 'jaminan Persetujuan cepat, bunga dan biaya transparan',
        Bo54: 'Silakan pilih bank tempat Anda ingin meminjam.',
        Bo55: 'Pinjaman langsung dari bank, tidak memerlukan',
        Bo56: 'historis',
        Bo57: 'Kata Sandi Pengingat',
        Bo58: 'Kata Sandi Pengingat dapat digunakan untuk login aplikasi',
        Bo59: 'Hasilkan',
        Bo60: 'Lihat',
        Bo61: 'Salin',
        Bo62: 'Sayang sekali',
        Bo63: 'Jangan berkecil hati, sesuaikan strategi dan coba lagi!',
        Bo64: 'Selamat',
        Bo65: 'Tanda yang bagus! Pertahankan kondisi ini dan raih prestasi lebih baik lagi',
        Bo66: 'Lanjutkan Pemesanan',
        Bo67: 'Untuk menjaga keamanan dana Anda, harap perhatikan hal-hal berikut saat melakukan pembayaran kembali:',
        Bo68: '1. Hanya gunakan alamat pembayaran resmi yang disediakan oleh platform: Semua alamat pembayaran yang diperoleh dari sumber lain selain saluran resmi platform tidak valid.',
        Bo69: '2. Waspadalah terhadap penipuan: Jika seseorang menghubungi Anda secara pribadi dan memberikan apa yang disebut alamat pembayaran, jangan mudah percaya.',
        Bo70: '3. Tanggung jawab keamanan dana: Jika terjadi kehilangan dana akibat penggunaan alamat pembayaran yang salah, platform tidak akan bertanggung jawab dan dapat menuntut tanggung jawab hukum sesuai dengan hukum.',
        Bo71: 'Harap tetap waspada dan pastikan untuk melakukan operasi pembayaran kembali melalui saluran resmi untuk melindungi keamanan properti Anda!',
        Bo72: 'Pemberitahuan Keamanan',
        Bo73: 'Sudah tahu',
        Bo74: 'Akun Anda saat ini adalah akun virtual, semua dana di dalam akun hanya digunakan untuk transaksi simulasi dan tidak dapat melakukan penarikan uang asli. Harap waspada dan hindari risiko terkait!',
    },

    Purchase: {
        Pu1: "Pembelian",
        Pu2: 'Pilih pembayaran',
        Pu3: 'Pilih metode pembayaran',
        Pu4: 'Konfirmasi perintah',
        Pu5: 'Arrival',
        Pu6: 'Balance',
        Pu7: 'jumlah pembelian',
        Pu8: ' jumlah',
        Pu9: " jumlah jualan",
        Pu10: 'Semua',
        Pu11: 'Minimum tidak bisa kurang dari',
        Pu12: 'Maksimum tidak bisa lebih besar dari',
        Pu13: 'Harga referensi',
        Pu14: 'Pengendalian bayaran',
        Pu15: 'Buy Now',
        Pu16: 'Immediately sell',
        Pu17: 'Buy',
        Pu18: 'Sell',
        Pu19: 'Pilih metode pembayaran',
        Pu20: 'Metode pembayaran',
        Pu21: 'Tambah metode pembayaran',
        Pu22: 'Tambah',
        Pu23: 'Nama pengguna',
        Pu24: 'Nomor kartu bank',
        Pu25: 'kode IFSC',
        Pu26: 'Nomor ponsel',
        Pu27: 'Konfirmasi',
        Pu28: 'Konfirmasi perintah',
        Pu29: 'Ya!',
        Pu30: 'Anda telah berhasil menarik dana',
        Pu31: 'Status',
        Pu32: 'Selesai',
        Pu33: 'Jumlah yang diterima',
        Pu34: 'Buy',
        Pu35: 'Sell',
        Pu36: 'Nama uang',
        Pu37: 'Total transaksi jumlah',
        Pu38: 'Quantity',
        Pu39: 'Harga',
        Pu40: 'Status',
        Pu41: 'Waktu',
        Pu42: 'Harga',
        Pu43: 'sukses',
        Pu44: 'gagal',
        Pu45: 'Proses',
        Pu46: 'Expired',
        Pu47: "Ditolak",
        Pu48: 'Untuk',
        Pu49: 'Website resmi',
        Pu50: 'Buku Putih',
        Pu51: 'Perkenalan',
        Pu52: 'Link web resmi',
    },
    nhome: {
        Nh1: 'Salah satu bursa mata uang kripto terbesar di dunia dan platform yang dapat Anda percayai',
        Nh2: '3. Ada lebih dari satu juta pengguna terdaftar di platform ini, dan volume perdagangan harian melebihi 10.00000000USTD，Bergabunglah dengan kami sekarang dan ikuti para ahli perdagangan untuk berinvestasi dan berdagang',
        Nh3: 'Volume perdagangan 24 jam',
        Nh4: 'Pengguna',
        Nh5: 'Diversifikasi produk dan layanan',
        Nh6: '——Pilih lebih banyak layanan dan jelajahi kemungkinan tanpa batas',
        Nh7: 'Transaksi kontrak',
        Nh8: 'Perdagangan spot',
        Nh9: 'Perdagangan opsi',
        Nh10: 'Transaksi mata uang yang sah',
        Nh11: '10. Proyek mata uang dengan likuiditas tertinggi, biaya pending order terendah, likuiditas baru yang efisien, berkualitas tinggi, dan sangat baik',
        Nh12: 'Menyediakan layanan perdagangan ratusan mata uang berkualitas tinggi，Aman dan andal, dengan tingkat transaksi pasar terendah',
        Nh13: 'Jumlah peserta terbanyak, gameplay adil dan adil, dan peluangnya tinggi',
        Nh14: ' Beli koin dengan cepat dengan satu klik, memberi Anda cara yang efisien dan nyamanSistem perdagangan waktu nyata. Setoran dan penarikan modal Anda juga dapat ditarik secara instan.',
        Nh15: 'Mata uang kripto populer',
        Nh16: 'Lihat selengkapnya',
        Nh17: 'Keunggulan kami',
        Nh18: 'Memiliki sistem pengendalian risiko keamanan terbaik di dunia',
        Nh19: 'Perlindungan seluruh aset pengguna',
        Nh20: '—Ini adalah platform yang dipercayai',
        Nh21: 'Metode penyimpanan offline',
        Nh22: 'etode enkripsi multi-faktor',
        Nh23: '24*7 Day platform monitoring',
        Nh24: 'Platform perdagangan aset digital terkemuka',
        Nh25: 'Perdagangan aset digital yang kaya dan layanan manajemen aset untuk memenuhi beragam kebutuhan perdagangan',
        Nh26: ' Mulai berdagang kapan saja, di mana saja',
        Nh27: 'Sepenuhnya mendukung sistem iOS dan Android.。',
        Nh28: 'Pindai kode QR untuk mengunduh',
        Nh29: 'Growth chart',
        Nh30: 'Decline List',
        Nh31: 'Transaction volume list',
        Nu32: 'Global leading digital asset trading platform',
        Nu33: '- Rich digital asset trading and asset management services to meet diverse trading needs',
        Nu34: 'Start trading and experience the best cryptocurrency journey',
        Nu35: 'The minimum length should not be less than 5',
        Nu36: 'Quick coin buying',
        Nu37: 'Buy coins',
        Nu38: '1. A single transaction of 300W-1 billion IDR.',
        Nu39: '2. After receiving the payment account, please complete the transfer within the specified time. If it exceeds the specified time, please contact customer service to confirm whether the order is valid.',
        Nu40: '3.completing the transfer, please provide the transaction account or account UID, as well as a detailed transfer screenshot and valid personal identification',
        Nu41: 'Click to know'
    },
    common: {
        logins: 'masuk...',
        login: 'Gabung',
        register: 'daftar',
        loginregister: "masuk Daftar",
        logout: 'keluar',
        tip: 'Tips yang baik',
        logintip: 'silahkan masuk terlebih dahulu',
        expect: 'Pantau terus!',
        delete: 'konfirmasi untuk menghapus?',
        nodata: 'Tidak ada catatan',
        set: 'mempersiapkan',
        update: 'Merevisi',
        slogan: "Pilih secara ketat aset digital global berkualitas tinggi",
        subslogan: "Tekun mengabdi selama 101 tahun",
        more: "Lagi",
        please: "Tolong dulu,",
        pleaseselect: "tolong pilih",
        searchplaceholder: "Masukkan nama mata uang untuk mencari",
        searchplaceholderswap: "Masukkan nama kontrak untuk mencari",
        loading: "memuat...",
        close: "penutup",
        ok: "Tentu"
    },
    header: {
        index: 'Rumah',
        exchange: 'Pertukaran koin ke koin',
        otc: 'transaksi mata uang fiat',
        kefu: 'Pusat Bantuan',
        asset: 'Pusat Keuangan',
        ucenter: 'Pusat Akun',
        service: 'pengumuman',
        downloadapp: "Pindai kode QR untuk mengunduh dan menginstal",
        appdownlaod: 'Unduhan aplikasi',
        usercenter: "Pusat Pribadi",
        helpcenter: "Pusat Bantuan",
        aboutus: "tentang",
        partner: "pasangan",
        bzb: "BZB",
        assetmanage: "Pengelolaan Dana",
        trademanage: "Manajemen Perdagangan",
        activity: "Aktivitas terbaru",
        lab: "peluncuran ico",
        ctc: "mata uang fiat C2C",
        labdetail: "Laboratorium BIPPAX ● Berbagi hasil inovasi",
        invite: "Mitra Promosi",
        whitepaper: "kertas putih",
        scandownload: "Pindai untuk mengunduh APLIKASI",
        innovationmanage: "Manajemen Inovasi",
        swap1: "kontrak abadi",
        swap2: "Kontrak abadi (pencocokan)",
        swap3: "CFD",
        swap4: "Kontrak Kedua",
        cexchange: "Penukaran cepat",
        option: "kontrak opsi",
        news: "informasi"
    },
    sectionPage: {
        ptaqTitle: 'Keamanan platform',
        ptaqContent: 'Menggunakan enkripsi algoritma hash, sertifikasi keamanan terkemuka di dunia',
        ptslTitle: 'Kekuatan platform',
        ptslContent: 'Platform perdagangan Bitcoin terbesar di dunia',
        newsTitle: 'APLIKASI multi-terminal',
        brandTitle: "Tentang BIPPAX",
        brandDetail: "Jujur | Adil | Bergairah | Terbuka",
        brandDesc1: "bippaxcoins.com didirikan oleh sekelompok peserta awal dan ahli Bitcoin. Anggota inti tim berasal dari perusahaan terkenal seperti Google, Microsoft, Alibaba, dan Tencent. Mereka memiliki kemampuan R&D yang mendalam dan pengalaman yang kaya dalam bidang mengoperasikan produk Internet.",
        brandDesc2: "bippaxcoins.com diposisikan sebagai penyedia layanan blockchain dasar dan berkomitmen untuk menyediakan platform perdagangan aset kripto berkualitas tinggi kepada pengguna global. Ini menganut prinsip dasar 'jangan berbuat jahat', bersikeras melayani pelanggan jujur, adil dan antusias, serta terbuka untuk Kami menyambut semua mitra/proyek yang bermanfaat bagi kepentingan mendasar pengguna.",
        gettingstart: "Memulai | Membeli Koin dengan Cepat",
        officialstart: "Saluran bantu entri pemula resmi BIPPAX",
        oneminutebuy: "saluran fiat",
        oneminutebuytips: "Beli dan jual Bitcoin dengan RMB, dll.",
        baseknow: "Dasar-Dasar Blockchain",
        baseknowtips: "Dasar-Dasar Blockchain dan Bitcoin",
        baseexchange: "Memulai perdagangan",
        baseexchangetips: "Pengenalan dasar perdagangan mata uang kripto untuk pemula",
        usersocial: "Komunitas Pendatang Baru",
        usersocialtips: "Pertukaran pengalaman, berbagi informasi",
        mainboard: "Area perdagangan mainboard",
        preview: "halaman sebelumnya",
        nextpage: "halaman berikutnya",
        downloadwhite: 'Unduh kertas putih (atau klik kanan pada kertas putih -> "Simpan sebagai...")'
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: 'Pilihan Anda',
        COIN: 'Mata Uang',
        favor: 'favorit',
        symbol: 'Pasangan dagang',
        NewPrice: 'Harga terbaru',
        ExchangeNum: 'Jumlah transaksi',
        Change: 'naik dan turun 24 jam',
        OpenPrice: 'Harga pembukaan',
        PriceTrend: 'Tren Harga',
        Operate: 'Operasi',
        Exchange: 'Pergi berdagang',
        trading: "Berdagang sekarang",
        high: "harga tertinggi 24 jam",
        low: "harga terendah 24 jam"
    },
    swapAssets: {
        Br1: 'Pengembalian langganan',
        Br2: 'Pembelian berlangganan',
        Br3: 'Transfer ke rekening kontrak',
        Br4: 'Transfer keluar rekening kontrak',
        Br5: 'Keuntungan dan kerugian kontrak abadi',
        Br6: 'Akhir',
        Br7: 'Akun kontrak (standar U)',
        Br8: 'Saldo Dompet',
        Br9: 'Harga saat ini',
        Br10: 'Buka panjang',
        Br11: 'Buka pendek',
        Br12: 'Sembunyikan kontrak lain',
        Br13: 'Tutup posisi dengan satu klik',
        Br14: 'Batalkan semua pesanan',
        Br15: 'Koreksi keseimbangan kontrak biasa',
    },
    exchange: {
        Wholehog: 'Yang paling bisa kamu jual',
        coin: 'mata uang',
        simbol: "Pasangan dagang",
        lastprice: 'Harga terbaru',
        daychange: 'naik dan turunnya 24 jam',
        market: 'pasar',
        favorit: 'Koleksi',
        do_favorite: 'Favorit',
        cancel_favorite: 'Batalkan favorit',
        type: "ketik",
        dealamount: "jumlah kesepakatan",
        high: 'tinggi',
        low: 'rendah',
        vol: 'volume 24 jam',
        buy: 'beli',
        sell: 'Jual',
        limited_price: 'batas harga',
        market_price: 'harga pasar',
        fees_rate: 'tarif',
        balance: 'Aset',
        or: 'atau',
        starttrade: 'Mulai berdagang',
        canuse: 'tersedia',
        recharge: 'mengisi ulang',
        buyprice: 'harga beli',
        buynum: 'Jumlah pembelian',
        amount: 'Jumlah transaksi',
        buyin: 'beli',
        disablebuyin: "Nonaktifkan pembelian pasar",
        buytip: 'Beli dengan harga optimal',
        sellprice: 'harga jual',
        sellnum: 'Volume penjualan',
        sellout: 'Jual',
        disablesellout: "Nonaktifkan penjualan pasar",
        selltip: 'Harga penjualan terbaik',
        curdelegation: 'Delegasi saat ini',
        hisdelegation: 'Sejarah delegasi',
        realtransaction: 'transaksi waktu nyata',
        num: 'Kuantitas',
        price: 'harga',
        direction: 'arah',
        time: 'waktu',
        stall: 'kios',
        total: 'akumulasi',
        traded: 'ditransaksikan',
        action: 'aksi',
        undo: 'batalkan pesanan',
        delegasinum: 'Jumlah delegasi',
        done: 'Setuju',
        status: 'status',
        finished: 'selesai',
        canceled: 'dibatalkan',
        parted: "Transaksi sebagian",
        tip: 'tip',
        buyamounttip: 'Silakan masukkan jumlah pembelian',
        buyamounttipwarning: 'Jumlah pembelian tidak boleh lebih tinggi dari',
        success: 'Pengajuan berhasil',
        pricetip: 'Silakan masukkan jumlah transaksi',
        pricetipwarning: 'Jumlah transaksi tidak boleh lebih tinggi dari',
        sellamounttip: 'Silakan masukkan jumlah penjualan',
        sellamounttipwarning: 'Jumlah penjualan tidak boleh lebih tinggi dari',
        sellpricetip: 'Silakan masukkan harga jual',
        sellpricetipwarning: 'Harga jual tidak boleh lebih tinggi dari',
        undotip: 'Apakah Anda mengkonfirmasi pembatalan pesanan? ',
        cancelsuccess: "Pembatalan berhasil!",
        marketprice: 'harga pasar',
        expand: {
            time: 'waktu',
            price: 'harga',
            amount: 'kuantitas',
            fee: 'biaya penanganan',
        },
        realtime: 'berbagi waktu',
        kline: "Bagan garis K",
        depth: "peta kedalaman",
        publishstate0: "Acara akan segera dimulai, harap tunggu...",
        publishstate1: "Acara ini akan segera berakhir, silakan bertransaksi sesegera mungkin...",
        publishstate2: "Pesanan aktif sedang dikonsolidasikan, harap tunggu...",
        publishstate3: "Konsolidasi telah selesai, silakan berdagang dengan bebas...",
        publishdetail: "Rincian aturan aktivitas",
        publishprice: "Harga terbitan",
        publishamount: "jumlah total",
        publishcounttxt0: "Masih ada waktu tersisa sebelum acara dimulai",
        publishcounttxt1: "Masih ada waktu tersisa sebelum acara berakhir",
        publishcounttxt2: "Masih ada waktu tersisa sebelum likuidasi selesai",
        publikasikancounttxt3: "Aktivitas telah berakhir",
        dateTimeDay: "hari",
        dateTimeHour: "jam",
        dateTimeMinutes: "menit",
        dateTimeSeconds: "detik",
        moredetail: "detail lebih lanjut"
    },
    swap: {
        Sw1: 'Increase margin',
        Sw2: 'Reduce margin',
        Sw3: 'Increase',
        Sw4: 'Reduce',
        Sw5: 'Margin',
        Sw6: 'Maximum allowed',
        Sw7: 'The subsequent forced leveling price is',
        Sw8: 'The leverage ratio after is',
        Sw10: 'Increase contract margin',
        Sw11: 'Reduce contract margin',
        Sw12: 'Descriptive Text',
        Spsl1: 'Actual triggering time',
        Spsl2: 'Actual number of triggers',
        Spsl3: 'Actual triggering direction',
        Spsl4: 'Actual trigger price',
        contract: "kontrak",
        swapindex: "berkelanjutan",
        coin: 'mata uang',
        simbol: "Pasangan dagang",
        volume: "Volume perdagangan",
        lastprice: 'Harga terbaru',
        daychange: 'naik turunnya 24 jam',
        market: 'pasar',
        favorit: 'Koleksi',
        do_favorite: 'Favorit',
        cancel_favorite: 'Batalkan favorit',
        type: "ketik",
        dealamount: "jumlah kesepakatan",
        high: 'tinggi',
        low: 'rendah',
        vol: 'volume 24 jam',
        buy: ' beli',
        sell: 'Jual',
        limited_price: 'batas harga pesanan',
        market_price: 'Pesanan harga pasar',
        spot_price: 'Ambil keuntungan dan hentikan kerugian',
        fees_rate: 'tarif',
        balance: 'Aset',
        or: 'atau',
        starttrade: 'Mulai berdagang',
        canuse: 'tersedia',
        recharge: 'mengisi ulang',
        buyprice: 'harga beli',
        buynum: 'Jumlah pembelian',
        amount: 'Jumlah transaksi',
        buyin: 'beli',
        disablebuyin: "Nonaktifkan pembelian pasar",
        buytip: 'Beli dengan harga optimal',
        sellprice: 'harga jual',
        sellnum: 'Volume penjualan',
        sellout: 'Jual',
        disablesellout: "Nonaktifkan penjualan pasar",
        selltip: 'Harga penjualan terbaik',
        curdelegation: 'Delegasi saat ini',
        hisdelegation: 'Delegasi sejarah',
        realtransaction: 'transaksi waktu nyata',
        num: 'Kuantitas',
        price: 'harga',
        direction: 'arah',
        time: 'waktu',
        stall: 'kios',
        total: 'akumulasi',
        traded: 'ditransaksikan',
        action: 'aksi',
        undo: 'batalkan pesanan',
        delegationnum: 'Jumlah delegasi',
        done: 'Setuju',
        status: 'status',
        finished: 'selesai',
        canceled: 'dibatalkan',
        parted: "Transaksi sebagian",
        tip: 'tip',
        buyamounttip: 'Silakan masukkan jumlah pembelian',
        buyamounttipwarning: 'Jumlah pembelian tidak boleh lebih tinggi dari',
        success: 'Pengajuan berhasil',
        pricetip: 'Silakan masukkan jumlah transaksi',
        pricetipwarning: 'Jumlah transaksi tidak boleh lebih tinggi dari',
        sellamounttip: 'Silakan masukkan jumlah penjualan',
        sellamounttipwarning: 'Jumlah penjualan tidak boleh lebih tinggi dari',
        sellpricetip: 'Silakan masukkan harga jual',
        sellpricetipwarning: 'Harga jual tidak boleh lebih tinggi dari',
        undotip: 'Apakah Anda mengkonfirmasi pembatalan pesanan? ',
        cancelsuccess: "Pembatalan berhasil!",
        marketprice: 'harga pasar',
        expand: {
            time: 'waktu',
            price: 'harga',
            amount: 'kuantitas',
            fee: 'biaya penanganan',
        },
        realtime: 'berbagi waktu',
        kline: "Bagan garis K",
        depth: "peta kedalaman",
        open: "Buka posisi",
        close: "Tutup posisi",
        latestdeal: "kesepakatan terbaru",
        myswapaccount: "Akun kontrak saya",
        accountmode: "mode akun",
        accountmargin: "Kontrak berganda",
        accountquanyi: "Total ekuitas akun",
        profitandloss: "Laba dan rugi yang belum direalisasi",
        principalAmount: "Margin yang tersedia",
        positionAmount: "margin posisi",
        frozenAmount: "margin beku",
        principalRate: "Tingkat pemanfaatan dana",
        zijinhuazhuan: "Transfer dana",
        up: "banyak",
        down: "kosong",
        canup: 'Bisa buka lama',
        candown: "Bisa dibuka pendek",
        cancloseup: "Posisi short dapat ditutup",
        canclosedown: "Posisi buy dapat ditutup",
        openup: "Beli untuk membuka posisi long",
        opendown: "Jual dan buka short",
        closeup: "Beli untuk menutup",
        closedown: "Jual untuk menutup posisi long",
        currentposition: "Posisi saat ini",
        assetsdetail: "Rincian Dana",
        marginMode1: "Margin Terisolasi",
        marginMode2: "Posisi penuh",
        modifyMarginModeTitle: "Ubah mode akun",
        modifyLeverage: "Sesuaikan kelipatan kontrak",
        moredetail: "detail lebih lanjut",
        shareNumber: "Zhang",
        entrustprice: "harga mempercayakan",
        triggleprice: "harga pemicu",
        openvolume: "volume terbuka",
        closevolume: "Tutup jumlah",
        triggleplaceholder: "Harga pesanan default adalah harga pasar",
        marketpriceplaceholder: "Transaksi dengan harga terbaik di pasar",
        levmaxtip: "Kelipatan kontrak tidak boleh lebih tinggi dari kelipatan tertinggi",
        levmintip: "Kelipatan kontrak tidak boleh lebih rendah dari kelipatan minimum",
        marginModeSuccessTip: "Mode akun kontrak berhasil diubah",
        noenoughbalance: "Margin akun tidak mencukupi",
        pleaseinputopenvolume: "Volume pembukaan harus lebih besar dari 0",
        pleaseinputcorrectopenvolume: "Silakan masukkan volume pembuka yang benar",
        pleaseinputrightentrustprice: "Silakan masukkan harga pesanan yang benar",
        noenoughposition: "Posisi yang dapat dilikuidasi tidak mencukupi",
        pleaseinputclosevolume: "Kuantitas penutupan harus lebih besar dari 0",
        pleaseinputcorrectclosevolume: "Silakan masukkan volume penutupan yang benar",
        pos_Pl: "Keuntungan",
        pos_Ratio: "Tingkat keuntungan",
        pos_pos: "Posisi",
        pos_canClose: "dapat diukur",
        pos_openPrice: "Harga pembukaan rata-rata",
        pos_leverage: "Kontrak berganda",
        pos_margin: "Margin Saat Ini",
        pos_mRatio: "Rasio Margin",
        pos_cmRatio: "Rasio margin pemeliharaan",
        pos_long: "panjang",
        pos_short: "pendek",
        ent_entrustType: "Posisi Buka/Tutup",
        ent_direction: "arah",
        ent_type: "Jenis kepercayaan",
        ent_trigglePrice: "harga pemicu",
        ent_entrustPrice: "Harga Percayakan",
        ent_tradedPrice: "Harga yang Diperdagangkan",
        ent_margin: "Margin",
        ent_volume: "Jumlah yang dipercayakan",
        ent_status: "Status titipan",
        ent_status1: "Mendelegasikan",
        ent_status2: "Dibatalkan",
        ent_status3: "Delegasi gagal",
        ent_status4: "Delegasi berhasil",
        ent_statusblast: "Likuidasi",
        ent_pl: "Penyelesaian keuntungan dan kerugian",
        ent_fee: "biaya penanganan",
        triggerpriceshouldbigger: "Harga pemicu harus lebih besar dari 0"
    },
    subscribe: {
        Su1: 'Halaman detail',
        Su2: 'Berlangganan',
        Su3: 'Langganan mata uang baru',
        Su4: 'Untuk memulai',
        Su5: 'sedang berlangsung',
        Su6: 'Akan diumumkan',
        Su7: 'jarak',
        Su8: 'mulai',
        Su9: 'Masalahkan harga',
        Su10: 'Perkiraan rasio untung dan rugi',
        Su11: 'Waktu mulai',
        Su12: 'Waktu pengumuman',
        Su13: 'Rincian',
        Su14: 'Berlangganan',
        Su15: 'Catatan langganan',
        Su16: 'Nama mata uang',
        Su17: 'Harga penerbitan',
        Su18: 'Harga penerbitan',
        Su19: 'Jumlah tawaran yang menang',
        Su20: 'Jumlah pengembalian dana',
        Su21: 'waktu',
        Su22: 'status',
        Su23: 'waktu',
        Su24: 'Jumlah berlangganan',
        Su25: 'Mata uang berlangganan',
        Su26: 'Masalahkan harga',
        Su27: 'Perkiraan untung dan rugi',
        Su28: 'Batas berlangganan',
        Su29: 'Waktu mulai berlangganan',
        Su30: 'Waktu berakhirnya langganan',
        Su31: 'Waktu pengumuman hasil',
        Su32: 'Perkiraan waktu peluncuran',
        Su33: 'Jumlah berlangganan',
        Su34: 'Mata Uang',
        Su35: 'Jumlah berlangganan',
        Su36: 'Waktu berlangganan',
        Su37: 'status',
        Su38: 'Akan diumumkan',
        Su39: 'Diumumkan',
        Su40: 'Informasi proyek',
        Su41: 'Quota',
        Su42: 'Berlangganan segera',
        Su43: 'semua',
        Su44: 'Kata sandi pembayaran',
    },
    option: {

        minute: 'menit',
        enter: 'Silakan masuk',
        title: "Kontrak Opsi",
        buyupreward: "Total hadiah pembelian",
        buydownreward: "Jumlah total pembelian downreward",
        quantity: "Jumlah pembukaan",
        myamount: "Posisi terbuka saya",
        buyup: "bullish",
        buydown: "bearish",
        history: "Hasil sebelumnya",
        seriers: "seri",
        period: "periode",
        currentoption: "Periode perkiraan ini",
        openprice: "harga pembukaan",
        currentprice: "harga saat ini",
        openprice1: "Harga pembukaan",
        closeprice: "Harga tutup",
        opentime: "waktu buka",
        closetime: "Waktu tutup",
        progress: "perkiraan kemajuan",
        loginFirst: "Silakan login terlebih dahulu!",
        selectAmount: "Silakan pilih jumlah taruhan",
        balancenotenough: "Saldo yang tersedia tidak mencukupi!",
        betsuccess: "Selamat! Taruhan berhasil!",
        noopening: "Tidak ada kontrak opsi yang tertunda",
        col_createTime: "Waktu pembuatan",
        col_direction: "Prediksi arah",
        col_result: "Hasil prediksi",
        col_optionNo: "Jumlah periode kontrak",
        col_betAmount: "Jumlah pembukaan",
        col_rewardAmount: "Jumlah bonus",
        col_fee: "Biaya pembukaan",
        col_winfee: "pompa",
        win: "sukses",
        lose: "kegagalan",
        wait: "sedang berlangsung",
        avaliablebalance: "Saldo tersedia",
        login: "Silakan login terlebih dahulu",
        kline: "Kutipan Waktu Nyata",
        or1: 'Harga Terbaru',
        or2: 'Waktunya bertaruh',
        or3: 'Jumlah taruhan',
        or4: 'Mata uang taruhan',
        or5: 'Jumlah lainnya',
        or6: 'Harga saat ini adalah harga eksekusi',
        or7: 'Transaksi historis',
        or8: 'Peluang',
        or9: 'Bonus',
        or10: 'Catatan transaksi',
        or11: 'Silakan pilih 4 jumlah taruhan USDT yang umum digunakan',

    },
    //----------------------
    activity: {
        all: "semua",
        prepare: "Akan memulai",
        ongoing: "sedang berlangsung",
        distributing: "Mendistribusikan",
        completed: "Selesai",
        progress: "kemajuan",
        totalsupply: "Total pasokan aktivitas",
        starttime: "waktu mulai",
        endtime: "waktu berakhir",
        viewdetail: "Lihat detail",
        attend: "Berpartisipasilah sekarang",
        tokendistribute: "Token sedang didistribusikan",
        baseinfo: "Informasi dasar",
        status: "status",
        activitytype: "Jenis Langganan",
        activitytype0: "Tidak diketahui",
        activitytype1: "Pertama kali online (pembelian terburu-buru)",
        activitytype2: "Pertama kali online (terbagi rata)",
        activitytype3: "Berbagi posisi",
        activitytype4: "Berlangganan gratis",
        activitytype5: "Langganan Mesin Cloud Mining",
        activitytype6: "Pelepasan Kunci",
        ruledetail: "ketikkan deskripsi",
        publishprice: "harga berlangganan",
        activitycoin: "mata uang aktivitas",
        acceptcoin: "Terima mata uang",
        holdcoin: "posisi mata uang yang dibutuhkan",
        limittimes: "Batas waktu pembelian pribadi",
        limitamount: "Jumlah batas pembelian pribadi",
        unlimited: "tidak ada batas",
        alreadyamount: "Jumlah yang dibeli",
        alreadyholdamount: "Total kepemilikan yang berpartisipasi dalam acara tersebut",
        myalreadyholdamount: "Kepemilikan saya yang berpartisipasi",
        leftamount: "jumlah yang tersisa",
        attention: "catatan",
        attentiontxt1: "1. Setelah mengirimkan untuk berpartisipasi dalam aktivitas jenis [Berbagi Posisi], [Langganan Gratis], [Langganan Mesin Cloud Mining], [Penguncian], aset akan dibekukan dan akan dicairkan atau dibuka kuncinya setelah aktivitas tersebut selesai lebih",
        attentiontxt2: "2. Setelah berpartisipasi dalam aktivitas sejenis [Berbagi Posisi], [Berlangganan Gratis], [Berlangganan Mesin Cloud Mining], [Penguncian], pengguna tidak boleh membatalkan lamaran partisipasi mereka",
        attentiontxt3: "3. Apabila acara dibatalkan karena pihak proyek atau faktor force majeure lainnya, maka aset yang dibekukan akan dikembalikan ke jalur semula",
        attentiontxt4: "* Hak interpretasi akhir dari acara ini adalah milik resmi BIPPAX (www.bippaxcoins.com)",
        inputamount: "Masukkan jumlah penukaran",
        inputholdamount: "Masukkan jumlah kunci",
        mybalance: "Saldo saya yang tersedia",
        holdtips: "Berpartisipasi dalam aktivitas berjenis [Hold Share] memerlukan penguncian posisi hingga aktivitas berakhir",
        pleaseinputamount: "Silakan masukkan jumlah penukaran",
        pleaseinputholdamount: "Silakan masukkan jumlah kunci",
        commitfailed: "Pengiriman partisipasi gagal!",
        minlimitamountfailed: "Jumlah penukaran tidak boleh kurang dari jumlah minimum penukaran!",
        maxlimitamountfailed: "Jumlah penukaran tidak boleh lebih besar dari jumlah pembelian maksimum!",
        limittimesfailed: "Berapa kali Anda berpartisipasi melebihi jumlah maksimum pembelian pribadi!",
        balancenotenough: "Saldo tidak mencukupi!",
        headertitledesc: "Laboratorium terbuka yang saling menguntungkan bagi investor, pihak proyek, bursa, dan pihak lainnya",
        currentdivided: "Posisi saya saat ini dibagi menjadi beberapa kontrak",
        leveloneCount: "Jumlah teman level satu yang dibutuhkan",
        submit: "kirim",
        tipsmobile: "Silakan masuk ke halaman komputer untuk berpartisipasi (www.BIPPAX.com)",
        tipsmobile1: "Silakan buka (www.BIPPAX.com) di komputer dan masuk ke area eksperimen inovasi untuk berpartisipasi",
        intvalue: "Silakan masukkan bilangan bulat",
        inputminingamount: "Masukkan jumlah mesin penambangan yang akan dibeli",
        moreactivity: "Lebih banyak aktivitas lain",
        releaseType: "tipe rilis",
        releaseType0: "Rilis yang sama",
        releaseType1: "Rilis dengan rasio yang sama",
        lock: "lepaskan",
        releaseDetail: "Rincian rilis",
        lockday: "hari",
        lockweek: "minggu",
        lockmonth: "bulan",
        lockyear: "tahun",
        releasePercent: "rasio rilis",
        lockFee: "Ambang Kunci",
        releaseTimes: "rilis beberapa kali",
        times: "kali"
    },
    uc: {
        verify: "Otentikasi nama asli",
        login: {
            noaccount: 'Tidak ada akun? ',
            register: 'Daftar',
            login: 'Masuk',
            welcomelogin: 'Selamat datang untuk masuk',
            usertip: 'Silakan masukkan email Anda',
            pwdtip: 'Silakan masukkan kata sandi',
            validatecodeload: 'Memuat kode verifikasi',
            validatemsg: 'Harap selesaikan verifikasi terlebih dahulu',
            forget: 'Lupa kata sandi Anda?',
            loginvalidate: 'Silakan masukkan nomor akun Anda',
            pwdvalidate1: 'Silakan masukkan kata sandi',
            pwdvalidate2: 'Panjang kata sandi tidak boleh kurang dari 6 karakter',
            success: 'Login berhasil',
            goregister: "Daftar sekarang",
            getlostpwd: "Lupa kata sandi"
        },
        forget: {
            title: "Ambil Kata Sandi",
            hasaccount: 'Sudah punya akun? Silakan klik untuk masuk',
            login: 'Masuk',
            sendcode: 'Kirim kode verifikasi',
            newpwd: 'Silakan masukkan kata sandi baru',
            confirmpwd: 'Harap konfirmasi lagi kata sandi',
            save: 'kirim',
            pwdvalidate1: 'Silakan masukkan kata sandi konfirmasi',
            pwdvalidate2: 'Kedua input kata sandi tidak konsisten!',
            resettelpwd: 'Reset kata sandi ponsel',
            resetemailpwd: 'Setel ulang kata sandi email',
            newpwdtip: 'Silakan masukkan kata sandi baru',
            pwdvalidate3: 'Panjang kata sandi tidak boleh kurang dari 6 karakter',
            telno: 'Nomor ponsel',
            mtelno: 'Otentikasi ponsel',
            memail: 'otentikasi email',
            smscode: 'Silakan masukkan kode verifikasi',
            teltip: 'Silakan masukkan nomor ponsel anda',
            smscodetip: 'Silakan masukkan kode verifikasi SMS',
            email: 'email',
            emailcode: 'Kode verifikasi email',
            emailtip: 'Silakan masukkan email Anda',
            emailcodetip: 'Silakan masukkan kode verifikasi email',
            resetpwdsuccess: 'Berhasil mengatur ulang kata sandi',
            smswarn: 'Mohon perhatiannya untuk memeriksa pesan teks',
        },
        finance: {
            center: 'Pusat Keuangan',
            personalassets: 'akun Binbi',
            swapassets: 'akun abadi',
            billdetail: 'Aliran aset',
            tradetail: 'Perdagangan pertambangan',
            paydividends: 'Dividen untuk memegang mata uang',
            invitingmining: 'hadiah penambangan undangan',
            charge: 'Mengisi',
            pickup: 'Tarik koin',
            fi1: 'Sembunyikan aset kecil',
            money: {
                M1: 'Jumlah yang diterima',
                M2: 'Jumlah transfer',
                M3: 'Nilai tukar',
                cointype: 'nama mata uang',
                balance: 'Aset yang tersedia',
                frozen: 'aset beku',
                operate: 'mengoperasikan',
                charge: 'Mengisi',
                pickup: 'Tarik koin',
                onkeytrans: "Transfer sekali klik",
                getaddress: 'Dapatkan alamat',
                resetsuccess: 'Dapatkan sukses',
                match: 'cocok',
                matchtip1: 'Jumlah GCX yang dapat dicocokkan',
                matchtip2: 'Silakan masukkan jumlah pertandingan',
                matcherr1: 'Silakan masukkan jumlah yang valid!',
                matcherr2: 'Melebihi jumlah pertandingan maksimum!',
                matchsuccess: 'Pemasangan berhasil!',
                needreleased: "Aset yang akan dilepaskan",
                totalassets: "Total aset yang dikonversi"
            },
            swap: {
                totalassets: "Konversi ekuitas akun",
                swap: "akun abadi",
                swaptype: 'Akun Kontrak',
                swapassets: "Ekuitas Akun",
                avabalance: "Margin yang tersedia",
                usebalance: "Margin yang digunakan",
                frozenbalance: "margin beku",
                profitandloss: "Laba dan rugi yang belum direalisasi",
                transfor: "Transfer dana",
                inputtransferamount: "Jumlah transfer",
                all: "Transfer semua",
                currencyaccount: "rekening mata uang",
                swapaccount: "akun kontrak abadi",
                clickchange: "Klik untuk mengganti arah transfer",
                avaamount: "Quota",
                pleaseselectwallet: 'Silakan pilih rekening transfer/ transfer terlebih dahulu',
                pleaseinputamount: "Silakan masukkan jumlah transfer",
                oktransfer: "Konfirmasi transfer"
            },
            record: {
                Please: 'Silakan pilih rentang tanggal',
                start_end: 'Waktu mulai dan berakhir',
                to: 'ke',
                operatetype: 'tipe operasi',
                search: 'pencarian',
                charge: 'isi ulang',
                pickup: 'Tarik',
                transaccount: 'Transfer',
                exchange: 'Pertukaran koin ke koin',
                otcbuy: 'Beli mata uang fiat',
                otcsell: 'jual mata uang fiat',
                activityaward: 'hadiah aktivitas',
                promotionaward: 'penghargaan promosi',
                dividend: 'dividen',
                vote: 'memilih',
                handrecharge: 'Isi ulang manual',
                match: 'cocok',
                activitybuy: "penebusan aktivitas",
                ctcbuy: "beli CTC",
                ctcsell: "jual CTC",
                redout: "Kirim amplop merah",
                redin: 'Terima amplop merah',
                chargetime: 'Waktu transaksi',
                type: 'ketik',
                fee: 'biaya penanganan',
                shouldfee: 'biaya penanganan harus dibayar',
                revenue: 'jenis pendapatan dan pengeluaran',
                re1: 'Akun',
                re2: 'Keluar dari akun',
                discountfee: 'Pengurangan biaya penanganan',
                realfee: 'biaya aktual',
                symbol: 'mata uang',
                num: 'Kuantitas',
                status: 'status',
                finish: 'Selesai',
                activitybuy: "penebusan aktivitas",
                ctcbuy: "beli C2C",
                ctcsell: "jual C2C",
                quickExchange: "pertukaran cepat",
                currentRate: "Nilai tukar saat ini",
                from: "dari",
                inputexchangeamount: "Masukkan jumlah penukaran",
                inputexchangepasswd: "Masukkan kata sandi transaksi",
                chooseTransCoinUnit: "Pilih mata uang konversi",
                inputTransAmount: "Masukkan jumlah konversi",
                predictAmount: "Perkiraan jumlah yang dapat ditukarkan",
                qamount: "Jumlah penukaran cepat",
                qrate: "Rasio pertukaran",
                qexamount: "Jumlah penukaran",
                withdrawcodein: "Tarik kode untuk menyetor koin",
                withdrawcodeout: "Tarik kode untuk menarik koin",
                contractfee: "biaya penanganan kontrak abadi",
                contractprofit: "Keuntungan Kontrak Abadi",
                contractloss: "kerugian kontrak abadi",
                optionfail: "Kontrak prediksi gagal",
                optionfee: "Perkiraan biaya penanganan kontrak",
                optionreward: "Prediksi bonus kontrak",
                other: "lainnya"
            },
            paydividende: {
                money_holding: 'Dividen kumulatif dari kepemilikan mata uang telah dikembalikan (ETH)',
                money_hold: 'Akumulasi mata uang yang menyimpan dividen yang akan dikembalikan (ETH)',
                paydividends: 'Dividen Token (ETH)',
                account_date: 'Waktu kedatangan akun',
                datehodld: 'Tanggal penyimpanan mata uang',
                start_end: 'Waktu mulai dan berakhir',
                to: 'ke',
                operatetype: 'tipe operasi',
                search: 'pencarian',
                charge: 'isi ulang',
                pickup: 'Tarik',
                transaccount: 'Transfer',
                exchange: 'Pertukaran koin ke koin',
                otcbuy: 'Beli mata uang fiat',
                otcsell: 'jual mata uang fiat',
                activityaward: 'hadiah aktivitas',
                promotionaward: 'penghargaan promosi',
                dividend: 'dividen',
                vote: 'memilih',
                handrecharge: 'Isi ulang manual',
                match: 'cocok',
                chargetime: 'Waktu transaksi',
                type: 'ketik',
                fee: 'biaya penanganan',
                symbol: 'mata uang',
                num: 'Kuantitas',
                status: 'status',
                finish: 'Selesai',
            },
            trade: {
                start_end: 'Waktu mulai dan berakhir',
                account_date: 'Waktu kedatangan akun',
                to: 'ke',
                operatetype: 'tipe operasi',
                search: 'pencarian',
                charge: 'isi ulang',
                pickup: 'Tarik',
                transaccount: 'Transfer',
                exchange: 'Pertukaran koin ke koin',
                otcbuy: 'Beli mata uang fiat',
                otcsell: 'jual mata uang fiat',
                activityaward: 'hadiah aktivitas',
                promotionaward: 'penghargaan promosi',
                dividend: 'dividen',
                vote: 'memilih',
                handrecharge: 'Isi ulang manual',
                match: 'cocok',
                chargetime: 'Waktu pembuatan pesanan',
                type: 'ketik',
                fee: 'Pengembalian biaya penambangan (BHB)',
                num: 'Kuantitas',
                status: 'status',
                finish: 'Selesai',
                transactionTime: 'waktu transaksi',
                symbol: 'Pasangan dagang',
                direction: 'Arah perdagangan',
                price: 'harga',
                entrustment: 'jumlah titipan',
                havedeal: 'Setuju',
                poundageAmount: 'biaya penanganan',
                exchangeOrderId: "ID Pesanan",
                mineAmount: "Jumlah koin yang ditambang (BHB)",
                buy: "beli",
                sell: "menjual",
                limit: "batas harga",
                market: "harga pasar",
                clear: "Kondisi bersih",
                turnover: "jumlah transaksi"
            },
            recharge: {
                recharge: 'mengisi ulang',
                symbol: 'mata uang',
                address: 'alamat penyetoran',
                copy: 'salinan',
                qrcode: 'kode QR',
                qrcodeaddress: 'Isi ulang alamat kode QR',
                msg1: 'Mohon jangan mengisi ulang aset non-mata uang apa pun ke alamat di atas, jika tidak, aset tidak akan diambil. ',
                msg2: 'Setelah Anda mengisi ulang ke alamat di atas, diperlukan konfirmasi dari seluruh node jaringan blockchain. Umumnya, deposit akan diterima setelah 3 konfirmasi jaringan dari jaringan blockchain utama. ',
                msg3: 'Jumlah isi ulang minimum',
                msgtop: 'Alamat ini hanya dapat mengisi ulang aset',
                msg3_1: "Pengisian ulang kurang dari jumlah minimum tidak akan dikreditkan ke akun.",
                msg4: 'Alamat isi ulang Anda tidak akan sering berubah dan dapat diisi ulang berulang kali; jika ada perubahan, kami akan berusaha sebaik mungkin untuk memberi tahu Anda melalui pengumuman situs web atau email. ',
                msg5: 'Pastikan komputer dan browser Anda aman untuk mencegah informasi dirusak atau dibocorkan. ',
                record: 'Rekaman isi ulang',
                copysuccess: 'Penyalinan berhasil! ',
                copyerr: 'Penyalinan gagal! Silakan salin secara manual',
                time: 'Waktu kedatangan',
                amount: 'jumlah isi ulang',
                gettingaddress: "Mendapatkan alamat isi ulang, harap tunggu...",
                getaddress: "Dapatkan alamat isi ulang",
                memotips: "Silakan masukkan Memo ini sesuai kebutuhan saat mengisi ulang, jika tidak, Anda akan kehilangan aset Anda.",
                withdrawrecharge: "Tarik kode untuk mengisi ulang",
                coderechargetip: "Silakan masukkan kode penarikan",
                rechargesuccess: "Selamat! Kode penarikan koin telah berhasil diisi ulang!",
                rechargeconfirm: "Konfirmasi isi ulang",
                status: "status"
            },
            withdraw: {
                pickup: 'Tarik koin',
                addressmanager: 'Manajemen alamat penarikan',
                withdrawbycode: 'tarik kode mata uang',
                withdrawcode: 'Kode penarikan',
                symbol: 'mata uang',
                address: 'Alamat penarikan',
                num: 'Jumlah penarikan',
                avabalance: 'Saldo tersedia',
                msg1: 'Jumlah penarikan lebih rendah dari',
                msg2: 'Ini akan dikreditkan secara otomatis ketika waktunya tiba, jika tidak diperlukan peninjauan manual',
                increase: 'menambah jumlah',
                tip1: 'Masukan maksimum',
                tip11: 'Sampai desimal, nilai minimumnya adalah',
                tip2: 'Nilai maksimumnya adalah',
                numtip1: 'Masukkan jumlah penarikan',
                fee: 'biaya penanganan',
                range: 'rentang',
                arriamount: 'Jumlah yang diterima',
                msg3: 'Jumlah penarikan minimum adalah',
                msg4: 'Koin',
                msg5: 'Untuk memastikan keamanan dana Anda, ketika kebijakan keamanan akun Anda berubah, kata sandi Anda diubah, atau Anda menggunakan alamat baru untuk menarik koin, kami akan melakukan peninjauan manual terhadap penarikan tersebut. Harap bersabar dan menunggu staf untuk menghubungi Anda melalui telepon atau email',
                msg6: 'Pastikan komputer dan browser Anda aman untuk mencegah informasi dirusak atau dibocorkan. ',
                record: 'Catatan penarikan',
                symboltip: 'Silakan pilih mata uang',
                networktip: 'jaringan',
                addresstip: 'Silakan isi alamatnya',
                numtip2: 'Silakan isi jumlah penarikan yang benar, nilai minimumnya adalah',
                numtip3: 'Jumlah penarikan tidak boleh kurang dari biaya penanganan',
                amounttip: 'Silahkan masukkan jumlah koin yang ingin ditarik',
                feetip1: 'Biaya penanganan minimum adalah',
                feetip2: 'Nilai maksimumnya adalah',
                time: 'Waktu penarikan',
                status: 'status',
                status_1: 'sedang ditinjau',
                status_2: 'Transfer sedang berlangsung',
                status_3: 'Gagal',
                status_4: 'Sukses',
                St5: 'Perkiraan harga likuidasi',
                St6: 'Total aset = saldo dompet + belum direalisasi',
                St7: 'Laba dan rugi yang belum direalisasi = laba dan rugi yang belum direalisasi dihitung menggunakan harga terkini untuk semua posisi terbuka',
                St8: 'Saldo dompet = transfer masuk - transfer keluar - realisasi untung dan rugi',
                St9: 'Ditolak',
                remark: 'Keterangan',
                add: 'Tambahkan',
                addresslist: 'daftar alamat',
                safevalidate: 'validasi keamanan',
                telno: 'Nomor ponsel',
                smscode: 'Kode verifikasi ponsel',
                second: 'kedua',
                clickget: 'Klik untuk mendapatkan',
                email: 'email',
                emailcode: 'Kode verifikasi email',
                save: 'simpan',
                delete: 'hapus',
                telerr: 'Nomor ponsel salah',
                emailerr: 'Email salah',
                codeerr: 'Kode verifikasi salah',
                remarktip: 'Silakan masukkan komentar',
                savemsg1: 'Penyimpanan gagal!',
                savemsg2: 'Simpan berhasil!',
                operate: 'mengoperasikan',
                fundpwdtip: 'Silakan masukkan kata sandi dana',
                click: 'klik',
                filtrate: 'Dapat disaring',
                txid: "TxId",
                generateCode: "Buat kode penarikan mata uang",
                withdrawcodelist: "Tarik daftar kode",
                withdrawcodestatus: "status",
                submit: "kirim",
                generatecodesuccess: "Kode penarikan berhasil dibuat",
                wi1: 'Jaringan',
                wi2: 'otentikasi keamanan',
                wi3: 'Jumlah yang diterima',
                wi4: 'alamat penerimaan',
                wi5: 'Tarik Jaringan Koin',
                wi6: 'Total jumlah penarikan',
                wi7: 'Biaya jaringan',
                wi8: 'Pastikan Anda memasukkan alamat penarikan yang benar dan jaringan penarikan yang Anda pilih cocok dengan alamat tersebut',
                wi9: 'Pesanan penarikan tidak dapat dibatalkan setelah dibuat',
                wi10: 'Lanjutkan',
                wi11: 'Kata sandi dana',
                wi12: 'Kode verifikasi ponsel',
                wi13: 'Kirim verifikasi',
                wi14: 'Kode verifikasi email',
                wi15: 'Kirim verifikasi',
                wi16: 'kirim',
            }
        },
        member: {
            usercenter: "Pusat Pribadi",
            securitycenter: 'pusat keamanan',
            securitysetting: 'pengaturan keamanan',
            accountsetting: 'Metode pembayaran',
            account: "Manajemen Akun",
            assets: "Pengelolaan Dana",
            exchange: "Manajemen Transaksi",
            curdelegate: "Delegasi saat ini",
            hisdelegate: "Delegasi sejarah",
            otc: "Manajemen OTC"
        },
        order: {
            ordercenter: 'Pusat Pesanan',
            myorder: 'Pesanan saya',
            myad: 'iklan saya',
        },
        regist: {
            Res1: 'Berkomposisi huruf dan angka huruf besar dan huruf kecil',
            hasaccount: 'Sudah punya akun? Silakan klik untuk masuk',
            login: 'Masuk',
            username: 'nama pengguna',
            country: 'negara',
            smscode: 'Kode verifikasi SMS',
            sendcode: 'Kirim kode verifikasi',
            resendcode: 'Kirim ulang(',
            pwd: 'Kata sandi masuk',
            repwd: 'Konfirmasi kata sandi',
            confrimpwd: 'Konfirmasi kata sandi',
            agreement: 'Saya telah membaca dan menyetujui',
            userprotocol: 'Perjanjian Pengguna',
            regist: 'Pendaftaran',
            teltip: 'Silakan masukkan nomor ponsel anda',
            telerr: 'Format nomor ponsel salah, silakan masukkan kembali',
            emailtip: 'Silakan masukkan email Anda',
            emailerr: 'Format email salah, silakan masukkan kembali',
            confirmpwdtip: 'Silakan masukkan kata sandi konfirmasi',
            confirmpwderr: 'Kedua masukan kata sandi tidak konsisten!',
            telregist: 'Pendaftaran ponsel',
            emailregist: 'Pendaftaran email',
            usernametip: 'Silakan masukkan nama pengguna',
            usernamemsg: 'Panjang nama pengguna tidak boleh kurang dari 3 karakter atau lebih dari 15 karakter',
            countrytip: 'Silakan pilih negara',
            smscodetip: 'Silakan masukkan kode verifikasi SMS',
            pwdtip: 'Silakan masukkan kata sandi login Anda',
            pwdmsg: 'Panjang kata sandi tidak boleh kurang dari 6 karakter',
            telno: 'Nomor ponsel',
            email: 'alamat email',
            agreementtip: 'Silakan klik untuk menyetujui',
            modaltitle: 'Harap verifikasi',
            promotion: 'kode undangan'
        },
        safe: {
            beneficiaryTitle: 'Informasi Penerima Manfaat',
            beneficiaryEmpty: 'Informasi penerima manfaat belum diatur',
            beneficiaryName: 'Nama Penerima Manfaat',
            beneficiaryIdNumber: 'Nomor Identitas Penerima Manfaat',
            beneficiaryMobilePhone: 'Nomor Ponsel Penerima Manfaat',
            beneficiaryNamePlaceholder: 'Silakan masukkan nama penerima manfaat',
            beneficiaryIdPlaceholder: 'Silakan masukkan nomor identitas penerima manfaat',
            beneficiaryMobilePlaceholder: 'Silakan masukkan nomor ponsel penerima manfaat',
            beneficiaryTip: 'Digunakan untuk mencatat dan memperbarui nama, nomor identitas, dan nomor ponsel penerima manfaat.',
            beneficiaryNameRequired: 'Silakan masukkan nama penerima manfaat',
            beneficiaryNameInvalid: 'Nama penerima manfaat harus terdiri dari 2 hingga 30 karakter',
            beneficiaryIdRequired: 'Silakan masukkan nomor identitas penerima manfaat',
            beneficiaryIdInvalid: 'Format nomor identitas penerima manfaat tidak valid',
            beneficiaryMobileRequired: 'Silakan masukkan nomor ponsel penerima manfaat',
            beneficiaryMobileInvalid: 'Format nomor ponsel penerima manfaat tidak valid',
            Ad1: 'Silakan mengunggah kartu keamanan sosial Anda, lisensi pengemudi, atau paspor',
            Ad2: "Naikkan salah satu berkas sebelum menyerahkan",
            Ad3: 'Full name',
            Ad4: 'Contact address',
            Ad5: 'Live streaming',
            Ad6: 'My Live',
            Ad7: 'Tambah gagal, maksimum 3 dapat ditambah',
            size: 'Ukuran gambar yang diunggah tidak boleh melebihi 5M',
            safelevel_low: 'Tingkat keamanan',
            safelevel_high: 'Tingkat keamanan',
            safelevel_medium: 'Tingkat keamanan',
            nickname: 'nama panggilan',
            bind: 'mengikat',
            binded: 'terikat',
            binding: 'sedang ditinjau',
            binderr: 'gagal',
            bindretry: 'Coba lagi',
            verifypass: "diautentikasi",
            verified: 'otentikasi nama asli',
            notverified: "Tidak terverifikasi",
            verifiedtip: 'Untuk memastikan keamanan akun Anda, harap selesaikan verifikasi nama asli sebelum berdagang! ',
            realname: 'nama asli',
            idcard: 'Nomor KTP',
            upload: 'Klik untuk mengunggah',
            upload_positive: 'foto depan KTP',
            upload_negative: 'Foto KTP negatif',
            upload_hand: 'Pegang foto KTP dan tanda tangan pribadi',
            save: 'simpan',
            reset: 'setel ulang',
            email: 'email',
            bindemail: 'Ikat email',
            loginpwd: 'Kata sandi masuk',
            emailcode: 'Kode verifikasi email',
            clickget: 'Klik untuk mendapatkan',
            second: 'kedua',
            phone: 'ponsel',
            bindphone: 'mengikat telepon',
            phonecode: 'Kode verifikasi ponsel',
            logintip: 'Gunakan saat masuk ke platform',
            edit: 'modifikasi',
            oldpwd: 'Kata sandi masuk asli',
            newpwd: 'Kata sandi login baru',
            confirmnewpwd: 'Konfirmasi kata sandi baru',
            fundpwd: 'Kata sandi dana',
            fundtip: 'Jika dana akun berubah, kata sandi dana perlu diverifikasi terlebih dahulu',
            set: 'mengatur',
            confirmpwd: 'Konfirmasi kata sandi',
            oldfundpwd: 'Kata sandi dana asli',
            newfundpwd: 'Kata sandi dana baru',
            newpwdmsg1: 'Silakan masukkan kata sandi login baru minimal 6 digit',
            newpwdmsg2: 'Kata sandi login baru tidak konsisten',
            pwdmsg1: 'Silakan masukkan kata sandi minimal 6 digit',
            pwdmsg2: 'Kata sandi tidak konsisten',
            emailtip: 'Silakan masukkan nomor email Anda',
            codetip: 'Silakan masukkan kode verifikasi',
            telnotip: 'Silahkan masukkan nomor ponsel anda',
            oldpwdtip: 'Silakan masukkan kata sandi asli',
            realnametip: 'Silakan masukkan nama asli Anda',
            idcardtip: 'Silakan masukkan nomor ID Anda',
            bindphonetip: 'Silakan ikat ponsel Anda terlebih dahulu!',
            resetfundpwd: 'Setel ulang kata sandi dana',
            upload_positivetip: 'Silakan upload foto depan KTP Anda',
            upload_negativetip: 'Silakan unggah foto sisi negatif KTP Anda',
            upload_handtip: 'Silakan upload foto KTP Anda',
            save_success: 'Simpan berhasil!',
            save_failure: 'Penyimpanan gagal!',
            idcard_verifymsg1: "1. Mendukung format JPG dan PNG, ukuran file kurang dari 8M; informasi pada sertifikat terlihat jelas, modifikasi atau pemblokiran tidak diperbolehkan, dan nomor serta nama sertifikat harus terlihat jelas.",
            idcard_verifymsg2: "2. Foto harus diambil tanpa topi, dan disarankan untuk tidak memakai riasan. Ciri wajah orang yang memegang ID terlihat jelas, dan lengannya terbuka seluruhnya.",
            idcard_verifymsg3: "3. Anda harus memegang ID dan salinan tulisan tangan (nama + tanggal lamaran) secara bersamaan. 'Semua tindakan saya di situs ini dilakukan oleh saya sendiri, saya sadar akan risiko yang relevan, dan saya bersedia untuk menanggung semua konsekuensi hukum atas akun ini.'",

        },
        account: {
            pagetitle: 'Ikat akun dengan nama asli',
            pagetip: 'Silakan atur metode pembayaran Anda dan pastikan untuk menggunakan nama asli akun Anda',
            backcardno: 'nomor rekening kartu bank',
            backcardtip: 'Informasi kartu bank pribadi tidak terikat',
            modify: 'memodifikasi',
            bind: 'mengikat',
            name: 'nama',
            bankaccount: 'Rekening bank',
            bankbranch: 'Cabang pembukaan rekening',
            bankno: 'nomor kartu bank',
            confirmbankno: 'Konfirmasi nomor kartu',
            fundpwd: 'Kata sandi dana',
            save: 'simpan',
            zfbaccount: 'akun Alipay',
            zfbaccounttip: 'Akun Alipay pribadi tidak terikat',
            wxaccount: 'akun WeChat',
            wxaccounttip: 'Akun WeChat pribadi tidak terikat',
            banknomsg1: 'Silakan masukkan nomor kartu bank yang benar',
            banknomsg2: 'Nomor kartu bank yang dimasukkan dua kali tidak konsisten!',
            verifiedmsg: 'Silakan lakukan verifikasi nama asli terlebih dahulu',
            bankaccountmsg: 'Silakan pilih bank untuk membuka rekening',
            bankbranchmsg: 'Silakan masukkan cabang tempat rekening dibuka',
            banknomsg: 'Silakan masukkan nomor kartu bank yang benar',
            fundpwdmsg1: 'Silakan masukkan kata sandi dana yang benar',
            fundpwdmsg2: 'Kata sandi tidak boleh kurang dari 6 karakter',
            zfbaccountmsg: 'Silakan masukkan nomor akun Alipay Anda',
            wxaccountmsg: 'Silakan masukkan akun WeChat Anda',
            save_success: 'Simpan berhasil!',
            save_failure: 'Penyimpanan gagal!',
            imgtip: 'Silakan unggah kode pembayaran Anda',
        },
        otcorder: {
            unpaid: 'belum dibayar',
            paided: 'dibayar',
            finished: 'selesai',
            canceled: 'dibatalkan',
            appealing: 'Menarik',
            searchtip: 'Masukkan nomor pesanan untuk memulai pencarian',
            orderno: 'nomor pesanan',
            created: 'Waktu pembuatan',
            symbol: 'Mata uang perdagangan',
            type: 'Jenis transaksi',
            type_sell: 'Jual',
            type_buy: 'Beli',
            tradename: 'Objek perdagangan',
            amount: 'kuantitas',
            money: 'jumlah',
            fee: 'biaya penanganan',
        },
        identity: {
            certified: "bersertifikat",
            placeholder: "Silakan isi alasan pembatalan",
            apply: 'Melamar menjadi pedagang',
            become: 'Menjadi pedagang bersertifikat BIPPAX dan menikmati lebih banyak keistimewaan bertransaksi',
            zhusnhu: "Pedagang memiliki stan iklan eksklusif untuk meningkatkan tingkat keberhasilan transaksi",
            tijiaoziliao: "Kirimkan informasi sertifikasi pedagang",
            place: "Silakan unggah informasi sertifikasi pedagang yang telah disiapkan ke platform dan kirimkan",
            tijiao: "Tinjauan sertifikasi pedagang Anda telah dikirimkan",
            tijiaosuc: "Selamat! Peninjauan sertifikasi pedagang Anda telah lulus",
            tijiaofail: "Maaf! Peninjauan sertifikasi pedagang Anda gagal",
            zhuxiaotijiao: "Permohonan pembatalan pedagang Anda telah dikirimkan",
            shenhefail: "Permohonan pembatalan pedagang Anda gagal lolos peninjauan",
            shenhesuc: "Permohonan pembatalan merchant Anda telah disetujui",
            shangjiazhuxiao: "Pedagang Batal",
            shenheshibai: "Audit gagal",
            shenagain: "pemeriksaan ulang",
            sheqinggain: "Ajukan permohonan kembali",
            reason: "alasan",
            shenqingtuibao: "Permohonan penyerahan diri",
            getquan: "Anda memiliki izin berikut",
            read: 'Saya telah membaca dan menyetujui',
            lijishenqing: "Daftar sekarang",
            tips: "tip",
            wufachexiao: "Anda sedang dalam proses membatalkan pendaftaran pedagang. Setelah Anda mengonfirmasi pengajuan permohonan, Anda tidak akan dapat membatalkannya.",
            suredo: "Apakah Anda yakin ingin melakukan operasi ini?",
            shuzizichan: "Bukti transaksi aset digital",
            gerenzichan: "Sertifikat aset digital pribadi",
            second: {
                line: "Bagaimana cara melamar menjadi pedagang?",
                step1: "Langkah pertama: siapkan materi lamaran merchant sesuai kebutuhan",
                step1c1: "Siapkan bahan lamaran berikut ini :",
                step1c2: "Nomor ponsel, ID WeChat, nomor QQ, sertifikat aset digital pribadi (gambar), sertifikat transaksi aset digital (gambar)",
                step2: "Langkah 2: Kirim lamaran",
                step2c: "Lengkapi informasi tinjauan sertifikasi pedagang yang perlu diisi dan diunggah, dan klik Kirim untuk ditinjau.",
                step3: "Langkah ketiga: tinjauan informasi",
                stepc: "Kami akan meninjau informasi aplikasi pedagang Anda dalam waktu 3-5 hari kerja. Harap perhatikan status peninjauan kapan saja, yang dapat dilihat di halaman pengiriman. Setelah lulus peninjauan, Anda dapat mempublikasikan iklan dalam mata uang resmi kawasan perdagangan.",
                agree: 'Setuju untuk dibekukan',
                agreec: "Sebagai titipan pedagang",
                shenqingchngweishangjia: "Melamar menjadi pedagang",
            },
            yuanyin: "alasan",
            tijiaoshenqing: "Kirim lamaran",
            bizhong: "Mata uang margin",
            shuliang: "Jumlah setoran",
            chosen: "Pilih mata uang",
            seat: 'Stan eksklusif',
            service: 'Layanan satu-ke-satu',
            lowfee: 'biaya penanganan lebih rendah',
            phone: 'ponsel',
            balance: 'Aset pribadi',
            cardphoto: 'Foto bagian depan dan belakang KTP',
            wx: 'WeChat',
            exchange: 'Apakah Anda pernah terlibat dalam perdagangan aset digital yang dijual bebas',
            handphoto: 'Foto pengguna yang memegang KTP',
            qq: 'QQ',
            ploy: 'Apakah ada strategi pengendalian risiko yang sesuai',
            agreement: '"Perjanjian Pedagang Bersertifikat"',
            applyfor: 'Konfirmasi lamaran',
            sendcode: 'Kirim kode verifikasi',
            confirm: 'OK',
            prepare: 'Siapkan informasi',
            review: 'Kirim untuk ditinjau',
            result: "Menunggu hasil",
            passed: 'Persetujuan berlalu',
            approve: 'Harap setujui perjanjian pedagang bersertifikat',
            emailtip1: 'Silakan kirim materi berikut melalui email ke',
            emailtip2: 'Kami akan meninjau permohonan Anda sesegera mungkin. ',
        },
        extension: {
            title1: 'Tautan promosi',
            title2: 'Promosikan teman',
            title3: 'Komisi Saya',
            linkdesc: 'URL berikut adalah alamat Anda untuk promosi ke dunia luar. Anda dapat mempromosikannya melalui teman, QQ, WeChat, Weibo, blog, forum, atau situs web Anda sendiri. Semua orang yang mengunjungi melalui alamat ini akan menjadi milik pengguna Anda, dan ketika pengguna ini mengirimkan strategi di situs ini, Anda dapat memperoleh komisi. Informasi promosi terperinci dapat dilihat di catatan akses. ',
            linktitle: 'Tautan promosi Anda',
            copy: 'salinan',
            copy_msg1: 'Penyalinan berhasil! ',
            copy_msg2: 'Penyalinan gagal! Silakan salin secara manual',
            username: 'nama pengguna',
            currrecharge: 'Transaksi saat ini',
            userlevel: 'tingkat yang disarankan',
            createdtime: 'Waktu pendaftaran',
            currcommission: 'Komisi saat ini',
            managerfee: 'Biaya manajemen',
            yuan: 'yuan',
            symbol: 'mata uang',
            amount: 'jumlah',
            remark: 'Keterangan',
            amounttime: 'waktu penerbitan',
        },
        promotion: {
            title: "Promosi saya",
            subtitle1: "Kartu Promosi Saya",
            subtitle2: "Pertukaran Catatan",
            subtitle3: "Undanganku",
            card_column0: "Kode Penukaran",
            card_column1: "Nama kartu",
            card_column2: "Mata uang kartu",
            card_column3: "Jumlah nominal kartu",
            card_column4: "Masa berlaku",
            card_column5: "Jumlah total",
            card_column6: "Ditebus",
            card_column7: "Waktu pengumpulan",
            my_column0: "Undang pengguna",
            my_column1: "Waktu pendaftaran",
            my_column2: "Status nama asli",
            gopromotion: "Materi Promosi",
            inputcardno: "Silakan masukkan kode penukaran",
            exchange: "Tukarkan sekarang",
            exchangesuccess: "Penukaran berhasil! Silakan buka manajemen aset untuk memeriksa saldo!",
            exchangewithcode: "Tukarkan kode"
        },
        activity: {
            navTitle: "Manajemen Inovasi",
            subNavTitle1: "Saya berpartisipasi",
            subNavTitle2: "Mesin penambangan saya",
            subNavTitle3: "Kunci Saya",
            column1: "nama",
            column2: "ketik",
            column3: "Jumlah langganan",
            column4: "Mata uang yang berpartisipasi",
            column5: "Unit langganan",
            column6: "Status saat ini",
            column7: "Volume transaksi",
            column8: "Waktu pembuatan",
            mColumn1: "Penambang",
            mColumn2: "nama",
            mColumn3: "Mata uang",
            mColumn4: "Periode",
            mColumn5: "Jumlah hari",
            mColumn6: "Ditambang",
            mColumn7: "Status",
            mColumn8: "Kapasitas Dasar",
            mColumn9: "Kapasitas produksi saat ini",
            mColumn10: "Total keluaran",
            mColumn11: "Tanggal Berakhir",
            mColumn12: "Tanggal pembuatan",
            lColumn1: "Posisi kunci",
            lColumn2: "Nama",
            lColumn3: "Mata uang",
            lColumn4: "Periode",
            lColumn5: "Jumlah hari",
            lColumn6: "Dirilis",
            lColumn7: "Status",
            lColumn8: "Kapasitas produksi dasar",
            lColumn9: "Kapasitas produksi saat ini",
            lColumn10: "Total keluaran",
            lColumn11: "Tanggal Berakhir",
            lColumn12: "Tanggal pembuatan",
        },
        mining: {
            title: "Daftar mesin penambangan saya",
            empty: "Belum ada mesin penambangan",
            day: "天",
            week: "minggu",
            month: "bulan",
            year: "tahun",
            invitetip1: "Kapasitas produksi mesin penambangan ini dapat ditingkatkan dengan mengundang teman. Setiap kali ada satu orang yang diundang untuk menebus mesin penambangan, maka kapasitas produksi akan meningkat.",
            invitetip2: "%, batas atas peningkatan kapasitas produksi",
            miningUnit: "Mata uang keluaran",
            miningPeriod: "Periode Keluaran",
            miningDays: "Waktu Penambangan",
            miningedDays: "Waktu yang ditambang",
            miningDaysProfit: "Kapasitas produksi dasar",
            miningCurrentDaysProfit: "Kapasitas produksi aktual",
            status0: "Untuk dikerahkan",
            status1: "Dikerahkan",
            status2: "Berakhir"
        },
        locked: {
            title: "Daftar kunci saya",
            empty: "Belum ada kunci",
            day: "天",
            week: "minggu",
            month: "bulan",
            year: "tahun",
            invitetip1: "Kapasitas produksi gudang terkunci ini dapat ditingkatkan dengan mengundang teman. Setiap kali ada satu orang yang diundang untuk berpartisipasi dalam gudang terkunci, kapasitas produksi akan ditingkatkan.",
            invitetip2: "%, batas atas peningkatan kapasitas produksi",
            miningUnit: "Rilis mata uang",
            miningPeriod: "periode rilis",
            miningDays: "Total periode rilis",
            miningedDays: "Periode Dirilis",
            miningDaysProfit: "Rilis Dasar",
            miningCurrentDaysProfit: "Rilis aktual",
            status0: "Akan dirilis",
            status1: "Melepaskan",
            status2: "Berakhir",
            totallocked: "Total posisi terkunci"
        },
        api: {
            apiAdmin: "Manajemen API",
            createApi: "Buat Kunci API baru",
            mark: "komentar API",
            bindAddress: "IP resmi (kunci untuk alamat IP resmi berlaku selama 90 hari)",
            hint: 'petunjuk',
            part1: "Kami memberi Anda API canggih yang melaluinya Anda dapat menggunakan layanan seperti penyelidikan pasar dan perdagangan otomatis. Lulus",
            apiDoc: "Dokumentasi API",
            howUse: "Lihat cara menggunakan.",
            part2: "Setiap pengguna dapat membuat hingga 5 set Kunci API",
            part3: 'Mohon untuk tidak mengungkapkan Kunci API Anda untuk menghindari hilangnya aset. Untuk alasan keamanan, disarankan untuk mengikat IP ke Kunci API. Setiap Kunci API dapat diikat ke maksimal 5 IP. Isikan satu alamat secara langsung , dan gunakan beberapa alamat IP Pisahkan dengan koma setengah lebarnya, seperti',
            myApiKey: 'Kunci API Saya',
            ipAddress: "alamat ip",
            createTime: "Waktu pembuatan",
            accessKey: "kunci akses",
            bindIpAddress: "Ikat alamat IP",
            ioDays: "Sisa masa berlaku (hari)",
            operation: "operasi",
            create: "buat",
            edit: "sunting",
            delete: "hapus",
            sureDelete: "Apakah Anda yakin ingin menghapus?",
            tips: "Kuncinya hanya ditampilkan ketika ditambahkan, harap simpan tepat waktu",
            copy: "salin",
            access: "akses",
            okText: "Konfirmasi",
            cancel: "membatalkan"
        }
    },
    cms: {
        newshelp: 'Bantuan pemula',
        appdownload: 'unduhan aplikasi',
        onlineservice: 'layanan pelanggan online',
        faq: 'Pertanyaan yang Sering Diajukan',
        notice: 'pengumuman',
        servicecenter: 'Pusat Layanan Pelanggan',
        about: 'tentang',
        joinus: 'Bergabunglah dengan kami',
        aboutus: 'Tentang kami',
        exchangerule: 'Aturan perdagangan',
        useprotocol: 'Gunakan protokol',
        feenote: 'Deskripsi biaya',
        merchantprocotol: 'Perjanjian Pedagang',
        features: "Fitur Platform",
        contactus: "Hubungi kami",
        noticelist: 'Daftar pemberitahuan',
        nextnotice: 'artikel berikutnya',
        prevnotice: "artikel sebelumnya",
        notexist: "Pengumuman yang anda kunjungi tidak ada atau telah dihapus!",
        otherhelp: "Artikel di grup ini",
        scanforshare: "Pindai untuk berbagi",
        download: "Unduh sekarang",
        downloadslogan: "BIPPAXAPP - Platform Perdagangan Aset Digital Global"
    },
    description: {
        // message1: 'Teknologi keamanan tingkat bank seperti SSL dan verifikasi identitas dinamis memastikan keamanan transaksi; mendukung berbagai transaksi mata uang digital',
        // message2: 'Ambang masuk proyek yang ketat untuk memastikan kepentingan pengguna platform;\ndeposit 100%, isolasi dompet panas dan dingin untuk memastikan keamanan dana pengguna',
        // message3: 'Platform perdagangan aset digital BIPPAX mendukung 1.000 transaksi per detik, memberikan pengalaman\n perdagangan yang menyenangkan bagi pengguna',
        title1: 'Keamanan tingkat finansial',
        title2: 'Deposit dan penarikan yang sangat cepat',
        title3: 'Layanan Global',
        title4: 'Aset yang dipilih dengan cermat',
        message1: 'Sistem pengendalian risiko keuangan yang komprehensif dan sistem anti-pencurian, dompet panas dan dingin, dan sistem multi-tanda tangan memastikan keamanan dana',
        message2: 'Setoran dan penarikan dapat diselesaikan paling cepat dalam 3 menit, dengan tinjauan online manual 24 jam untuk melindungi pelanggan agar tidak kehilangan peluang investasi terbaik',
        message3: 'Cakupan jaringan layanan bisnis global membantu Anda berinvestasi dalam aset kripto global dan berdagang dengan pengguna global',
        message4: 'Pilih dengan ketat proyek enkripsi berkualitas tinggi dan filter 80% proyek berisiko sangat tinggi untuk Anda',
        message5: 'BIPPAX (www.bippaxcoins.com) klien seluler platform perdagangan aset kripto digital internasional, dengan fokus pada pengalaman perdagangan perangkat genggam',
        scanqrcode: "Pindai kode QR dan unduh APLIKASI",
        aboutdesc1: "BIPPAX (www.bippaxcoins.com) adalah platform perdagangan aset digital terkemuka di dunia. Terdaftar di Kepulauan Cayman dan tim operasi intinya berlokasi di Hong Kong. Anggota inti BIPPAX (www.bippaxcoins.com) berasal dari perusahaan Internet dan keuangan terkemuka, sebagian besar anggotanya sangat percaya pada Bitcoin dan blockchain. Kami sangat yakin bahwa blockchain akan mengubah sistem keuangan monopoli tradisional dan membangun struktur sosial yang lebih demokratis dan otonom.",
        aboutdesc2: "Platform BIPPAX (www.bippaxcoins.com) memiliki struktur transaksi tingkat keuangan profesional dan mesin transaksi pencocokan memori konkurensi tinggi yang dikembangkan sendiri. Platform ini mengadopsi sistem dompet isi ulang yang sepenuhnya dingin + multi-tanda tangan + tinggi- perlindungan sistem serangan DDOS dan struktur transaksi lainnya, untuk menjamin keamanan aset pelanggan.",
        aboutdesc3: "Untuk memungkinkan pelanggan memahami peluang investasi dengan lebih baik, BIPPAX (www.bippaxcoins.com) mengadopsi manajemen datar dalam departemen layanan pelanggan dan telah membentuk mekanisme respons layanan yang sangat cepat. Manajer layanan pelanggan aset online 7*24 jam sepanjang tahun untuk menyediakan penarikan isi ulang aset kepada pelanggan dan layanan lainnya memastikan bahwa pelanggan dapat menyelesaikan penyetoran dan penarikan aset dalam waktu 25 menit.",
        aboutdesc4: "BIPPAX(www.bippaxcoins.com) secara ketat memilih proyek berkualitas tinggi dan menyediakan layanan penyimpanan aset yang aman dan stabil. BIPPAX(www.bippaxcoins.com) menganut konsep kejujuran, keadilan, antusiasme, dan keterbukaan dan berupaya menciptakan pertukaran terbaik yang aman, andal, efisien, dan ramah.",
        aboutdesc5: "Meskipun aset digital saat ini hanya ada dalam lingkaran kecil, kami percaya bahwa aset semacam ini yang dapat dikontrol sepenuhnya oleh semua orang pasti akan menjadi populer di masa depan. Mari kita bekerja sama dan menantikannya!",
        support: "dukungan teknis",
        report: 'Keluhan dan Saran',
        service: "Layanan Pelanggan",
        apply: "Permohonan untuk daftar mata uang",
        coop: 'Kerjasama Bisnis',
        community: "komunitas BIPPAX",
        wechat: "WeChat",
        addwechat: "Tambahkan BIPPAX01 sebagai teman WeChat dan masuk ke komunitas kesejahteraan WeChat",
        weibo: "weibo",
        twitter: "Twitter",
        biyong: "biyong",
        telegram: "telegram",
        medium: "Sedang",
        reddit: "reddit"
    },
    footer: {
        wechatkefu: "layanan pelanggan WeChat",
        notice: 'Pengumuman Platform',
        changjian: 'FAQ',
        shiyong: 'Perjanjian Penggunaan',
        feilv: 'deskripsi nilai',
        lianxi: 'Hubungi email',
        biyong: 'biyong',
        gsmc: 'Aset digital global berkualitas tinggi yang dipilih secara ketat',
        bah: 'ICP Shanghai No.13026899-3',
        gsjj: 'Tentang',
        gywm: 'Tentang kami',
        jrwm: 'Bergabunglah dengan kami',
        lxwm: 'Hubungi kami',
        yqlj: 'Tautan ramah',
        bzzx: 'Pusat Bantuan',
        xsrm: 'Tutorial Pemula',
        czzn: 'Panduan Isi Ulang',
        ptsm: 'Deskripsi Platform',
        fysm: 'Aturan perdagangan',
        fwtk: 'Perjanjian Pengguna',
        fltk: 'Deskripsi tarif',
        wechat: "Layanan Pelanggan WeChat",
        xszn: "Panduan Pemula",
        cjwt: "Pertanyaan Umum",
        mztk: "Penafian",
        ystk: "Kebijakan Privasi",
        tkxy: "Ketentuan Perjanjian",
        gybzb: "Tentang BZB",
        kfyx: "Email Layanan Pelanggan",
        swhz: 'Kerjasama Bisnis',
        sbsq: "Permohonan untuk daftar mata uang",
        jyzn: "Panduan Perdagangan",
        bzzl: "Informasi mata uang",
        tsjb: "laporan pengaduan",
        apidoc: "antarmuka API",
        zwkf: "Belum dibuka"
    },
    index: {
        circulation: "Peredaran Dana Keamanan dan Pembangunan BHB",
        hourEth: 'Konversi kumulatif pendapatan hari ini yang akan didistribusikan',
        yesterdayEth: 'Konversi kumulatif pendapatan terdistribusi kemarin',
        yesterday: 'Hasil penambangan kemarin',
        bhbTotal: "Jumlah peredaran BHB",
        bhbSecond: "Sirkulasi pasar sekunder BHB",
        checkMineprinciple: "Periksa Prinsip Penambangan",
        checkFlowVolum: 'Periksa deskripsi volume aliran',
        checkLockPosition: 'Periksa posisi kunci',
        BHBregister: "Pendaftaran akun BIPPAX",
        tibi: "Waktu dan batas penarikan",
        line_plane: "Paket online BHB, pengumuman sirkulasi dan pengembalian biaya",
        fenpeijizhi: 'Penjelasan mekanisme distribusi pendapatan BIPPAX',
        jiangli_jihua: "Rencana Hadiah Penambangan Undangan",
        friend_fanhuan: "Undang teman dan dapatkan biaya penanganan tambahan untuk pengembalian dana",
        welcome_title: 'Mulailah perjalanan mata uang kripto Anda',
        welcome_sub_title: 'Daftar akun BIPPAX dan menangkan bonus sambutan yang berlimpah. ',
        tel_or_email: 'Tertinggi/Email',
        max: 'tertinggi',
        download_code: 'Pindai KODE QR untuk mengunduh APLIKASI dan menerima hadiah selamat datang'
    },
    home: {
        login: {
            title: 'Perdagangan mata uang terbuka',
            desc: 'Mendukung 500+ koin dan berbagai alat perdagangan',
            btnText: 'Pergi berdagang'
        },
        unlogin: {
            title: 'Mulailah perjalanan mata uang digital Anda',
            desc: 'Daftar untuk menikmati paket hadiah bagi pendatang baru',
            placinfo: 'Ponsel/email',
            btnText: 'Daftar'
        },
        WelfareCenter: 'Pusat Kesejahteraan',
        Welcome_ceremony: 'Upacara Penyambutan',
        Airdrop: 'harus diterjunkan',
        DailyGain: 'Setiap hari',
        AirdropGift: 'Hadiah Airdrop',
        financial_management: 'Manajemen keuangan pilihan·',
        Zhoude: 'zhouzhoude',
        height_is: 'Gundam',
        Happiness: 'Karnaval Lima Berkah·',
        Monthly: 'bulanan',
        CarveUp: 'Mengukir',
        download: {
            transactions_anytime: 'Buka transaksi kapan saja, di mana saja',
            scan_code: 'Pindai kode untuk mengunduh',
            download_more: 'Unduh lebih banyak'
        },
        brand: {
            digital_platform: 'Platform perdagangan aset digital terkemuka',
            rich_digital: 'Layanan perdagangan aset digital dan manajemen aset yang kaya untuk memenuhi beragam kebutuhan perdagangan',
            High_quality_digital: 'Aset digital berkualitas tinggi',
            Turnover: 'Volume',
            safety_risk: 'Sistem pengendalian risiko keselamatan terbaik di dunia',
            multi_factor: 'Metode penyimpanan offline, metode enkripsi multi-faktor, pemantauan platform 24/7, perlindungan menyeluruh terhadap aset pengguna',
            Security_reserve: 'Cadangan keamanan',
            accident: '0 kecelakaan dalam 9 tahun',
            safetyrisk: 'Pengendalian risiko keselamatan tertinggi',
            choice_trusted: 'Pilihan dipercaya oleh jutaan pengguna',
            transaction_service: 'Pusat layanan transaksi lokal telah didirikan di banyak negara dan wilayah di seluruh dunia untuk menciptakan ekosistem blockchain multi-bisnis',
            ten_thousand: 'sepuluh',
            User_preference: 'Preferensi pengguna',
            Countries_covered: 'Negara yang dicakup'
        },
        trading: {
            digital_currency: 'Mulailah perjalanan mata uang digital Anda',
            register: 'Daftar',
            login: 'Masuk',
            currency_transaction: 'Transaksi mata uang terbuka',
            to_trade: 'Pergi berdagang'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/ch/index.js